/**
 * Created by Mr.Laptop on 03-05-2018.
 */
export var config = {
    // 'URL':'http://localhost'
    'URL':'https://api.lakshyapocketlab.com'
};

export default config;


// WEBPACK FOOTER //
// ./src/config/MainConfig.js